export default "__VITE_ASSET__B3U6xL____"